export const SCENES = {
  UNBIND_GOOGLE_2FA: '60006',
  API_MANAGEMENT_EDIT_IP: '30080',
  MAIN_ACCOUNT_EDIT_SUB_ACCOUNT_API: '30079',
  SUB_ACCOUNT_LOGIN: '30078',
  VIEW_API_SECRET_PWD: '30091',
  BIND_THIRD_APP_TELEGRAM: '30093',
  UNBIND_THIRD_APP_TELEGRAM: '30094',
  ANTIPHISHING_CODE: '31001',
};
